import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Columna 1: Empresa */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">JUSTCLEAN DEFUNCIÓN</h3>
            <p className="text-gray-400 mb-4 text-sm leading-relaxed">
              Servicio profesional de limpieza tras defunción en Barcelona. Más de 8 años de experiencia con máxima discreción y respeto.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://wa.me/34602365996"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-accent rounded-full hover:bg-green-600 transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="fab fa-whatsapp text-xl"></i>
              </a>
              <a
                href="tel:+34602365996"
                className="w-10 h-10 flex items-center justify-center bg-primary rounded-full hover:bg-red-700 transition-colors cursor-pointer"
                aria-label="Teléfono"
              >
                <i className="fas fa-phone text-xl"></i>
              </a>
            </div>
          </div>

          {/* Columna 2: Servicios */}
          <div>
            <h3 className="font-heading text-lg font-bold mb-4">Servicios</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Limpieza por Defunción
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Desinfección Profesional
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Eliminación de Olores
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Vaciado de Inmuebles
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Limpieza de Choque
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Preparación para Venta
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3: Empresa */}
          <div>
            <h3 className="font-heading text-lg font-bold mb-4">Empresa</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/empresa" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Quiénes Somos
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Nuestra Metodología
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Valores y Compromiso
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 4: Contacto */}
          <div>
            <h3 className="font-heading text-lg font-bold mb-4">Contacto</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <i className="fas fa-phone text-primary mt-1"></i>
                <div>
                  <p className="text-gray-400">Teléfono</p>
                  <a href="tel:+34602365996" className="text-white hover:text-primary transition-colors cursor-pointer">
                    +34 602 36 59 96
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="fas fa-envelope text-primary mt-1"></i>
                <div>
                  <p className="text-gray-400">Email</p>
                  <a href="mailto:info@defuncion.justclean.es" className="text-white hover:text-primary transition-colors cursor-pointer">
                    info@defuncion.justclean.es
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="fas fa-map-marker-alt text-primary mt-1"></i>
                <div>
                  <p className="text-gray-400">Zona de servicio</p>
                  <p className="text-white">Barcelona y área metropolitana</p>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="fas fa-clock text-primary mt-1"></i>
                <div>
                  <p className="text-gray-400">Horario</p>
                  <p className="text-white">Lunes a Domingo: 8:00 - 22:00</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Zonas de servicio */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <h4 className="font-heading text-lg font-bold mb-4 text-center">Zonas de Servicio en Barcelona</h4>
          <div className="flex flex-wrap justify-center gap-3 text-xs">
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Eixample</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Gràcia</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Sants-Montjuïc</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Sarrià-Sant Gervasi</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Les Corts</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">L'Hospitalet</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Badalona</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Sant Cugat</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Terrassa</Link>
            <span className="text-gray-700">•</span>
            <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Sabadell</Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm mb-2">
            &copy; {new Date().getFullYear()} JUSTCLEAN DEFUNCIÓN Barcelona. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs">
            Servicio profesional de limpieza tras defunción en Barcelona | Discreción y respeto garantizados
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
